import { ca } from '@cian/analytics';

export function trackConsultationRequestFormSubmit() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Click',
    label: 'send/call_me',
  });
}
